import { BusinessItem, ListingItem } from './CommonTypes';

export const listings: ListingItem[] = [
  {
    id: 1,
    name: '익선동 가까이에 위치한 모던한 공간 하녹운',
    address: 'Jongno-gu, Seoul',
    image: '/images/temp/test1.jfif',
  },
  {
    id: 2,
    name: '익선동 가까이에 위치한 모던한 공간 하녹운',
    address: 'Jongno-gu, Seoul',
    image: '/images/temp/test2.jfif',
  },
  {
    id: 3,
    name: '익선동 가까이에 위치한 모던한 공간 하녹운',
    address: 'Jongno-gu, Seoul',
    image: '/images/temp/test3.jfif',
  },
  {
    id: 4,
    name: '익선동 가까이에 위치한 모던한 공간 하녹운',
    address: 'Jongno-gu, Seoul',
    image: '/images/temp/test4.jfif',
  },
  {
    id: 5,
    name: '익선동 가까이에 위치한 모던한 공간 하녹운',
    address: 'Jongno-gu, Seoul',
    image: '/images/temp/test5.jfif',
  },
  {
    id: 6,
    name: '익선동 가까이에 위치한 모던한 공간 하녹운',
    address: 'Jongno-gu, Seoul',
    image: '/images/temp/test6.jfif',
  },
];

export const businessList: BusinessItem[] = [
  {
    id: 1,
    name: '프라우들리(주)',
    address: '서울특별시 종로구 창덕궁1길 13, 3층',
    image: '/images/temp/test1.jfif',
    businessNumber: '754-87-01238',
    paymentId: '1234567890',
    tel: '02-1123-4567',
    owner: '이동우',
    ecomRegNumber: '제 2022-서울종로-0247 호',
  },
  {
    id: 1,
    name: '(주)샐러드소프트',
    address: '서울특별시 성동구 아차산로 17길 49',
    image: '/images/temp/test1.jfif',
    businessNumber: '117-81-82240',
    paymentId: '1234567890',
    tel: '02-1123-4567',
    owner: '김태규',
    ecomRegNumber: '제 2022-서울성동-0247 호',
  },
];
